import { PortalConfiguration, PortalConfigurationType } from '@trnsact/trnsact-shared-types';
import { getDefaultConfigByType } from '../constants/defaultConfigByType';

export const getPortalConfigurationDefaultConfig = (
  vendorProfileId: string,
  type: PortalConfigurationType,
  isDealerUser: boolean = false
): PortalConfiguration => ({
  vendorProfileId,
  type,
  jsonDefinition: {
    config: getDefaultConfigByType(isDealerUser)[type],
  },
});
